module.exports = __webpack_public_path__ + "img/9D8F84_5D4544_D9D3C9_62555A-256px.ab4a0859.png";